import { storage } from '@uhg-abyss/web/tools/storage';
import { useEffect, useState } from 'react';

import { getIsSuperUser } from '../../../../common/CareTeamCard/CareTeamUtils';
import { Constants } from '../../../../common/Constants';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { getFeatureFlags } from '../../../../common/Utils/getFeatureFlag';
import { useGetCareTeam } from '../../../../hooks/useCareTeam/useCareTeam';
import { useHsidUuid } from '../../../../hooks/useHsidUuid/useHsidUuid';
import { useLagoon } from '../../../../hooks/useLagoon/useLagoon';
import { StoreKeys } from '../../../../hooks/useStore/state';
import { useStore } from '../../../../hooks/useStore/useStore';
import { useCareTeamStore } from '../../../../store/useCareTeamStore';
import { useNonGatedPcpStore } from '../../../../store/useNonGatedPcpStore';

export const CareTeamConfig = ({
  isFirstTimeForCareTeam = false,
  setIsFirstTimeForCareTeam,
}) => {
  const obapiMember = useStore(StoreKeys.OBAPI_MEMBERS);
  const featureFlags: [{ key: string; active: boolean }] = useLagoon(
    Constants.LAGOON_TABLE.FEATURE_FLAGS
  )();
  const [enableCareTeamView] = getFeatureFlags(featureFlags, [
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_CARE_TEAM_VIEW,
  ]);
  const [careTeam, getCareTeam] = useGetCareTeam({});
  const { setBookmarkedProviders } = useCareTeamStore();
  const allConfigs = useLagoon('config');
  const hsidUuid = useHsidUuid();

  const [superUser, setSuperUser] = useState(() =>
    storage.session.get(Constants.STORAGE_KEYS.SESSION.SUPER_USER)
  );

  useEffect(() => {
    const checkStorage = () => {
      const value = storage.session.get(
        Constants.STORAGE_KEYS.SESSION.SUPER_USER
      );
      setSuperUser(value);
    };

    window.addEventListener('updateSuperUser', checkStorage);

    // Clear store on mount - both sessionStorage and in-memory
    useNonGatedPcpStore.getState().clearNonGatedPrimaryCareData();

    return () => {
      window.removeEventListener('updateSuperUser', checkStorage);
    };
  }, []);

  useEffect(() => {
    const isSuperUser = getIsSuperUser(allConfigs);
    if (
      enableCareTeamView &&
      obapiMember &&
      obapiMember.length > 0 &&
      isFirstTimeForCareTeam &&
      isSuperUser != null
    ) {
      getCareTeam({
        variables: {
          groupNumber: obapiMember?.[0].policyNumber || '',
          toFetchChipCount: false,
          isSuperUser,
          ...(hsidUuid && { userId: hsidUuid }),
        },
      }).finally(() => {
        setIsFirstTimeForCareTeam(false);
      });
    }
  }, [obapiMember, superUser]);

  useEffect(() => {
    if (careTeam?.data?.getCareTeam?.providerIds) {
      setBookmarkedProviders(careTeam.data.getCareTeam.providerIds);
    }
  }, [careTeam?.data?.getCareTeam?.providerIds]);
  return null;
};
